<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(b, i) in items" :key="i" :to="{ path: b.path }">
            {{b.label}}
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>
<script>
    export default {
        name: 'breadCrumbs',
        props:['items']
    }
</script>

<style scoped>
    .el-breadcrumb {
        margin-bottom: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/_commons/breadcrumb.vue